module.exports = __webpack_public_path__ + "img/dataManage.e8e839ff.png";